/**
 * FinanceApp - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
export default function Card({ children, style, className = '', padding = 20 }) {
  return (
    <div
      className={`fade-in ${className}`}
      style={{
        background:   'var(--bg-card)',
        border:       '1px solid var(--border)',
        borderRadius: 12,
        padding,
        boxShadow:    'var(--shadow)',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function KpiCard({ label, value, sub, icon, color = 'var(--accent)', trend, style }) {
  const isUp = trend > 0;
  return (
    <Card style={{ borderLeft: `4px solid ${color}`, display: 'flex', gap: 16, alignItems: 'flex-start', ...style }}>
      <div style={{ width: 44, height: 44, borderRadius: 10, background: `${color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color }}>
        {icon}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>{label}</div>
        <div className="kpi-value">{value}</div>
        {(sub || trend !== undefined) && (
          <div style={{ fontSize: 12, marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}>
            {trend !== undefined && (
              <span style={{ color: isUp ? 'var(--success)' : 'var(--danger)', fontWeight: 500 }}>
                {isUp ? '▲' : '▼'} {Math.abs(trend)}%
              </span>
            )}
            {sub && <span style={{ color: 'var(--text-muted)' }}>{sub}</span>}
          </div>
        )}
      </div>
    </Card>
  );
}
